import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export function RefundPolicy() {
  const { language, t } = useLanguage();
  const navigate = useNavigate();
  const [returnTo, setReturnTo] = useState(null);

  useEffect(() => {
    const checkoutReturnTo = localStorage.getItem('checkoutReturnTo');
    if (checkoutReturnTo) {
      setReturnTo(checkoutReturnTo);
    }
  }, []);

  const handleBackClick = () => {
    if (returnTo) {
      window.location.href = returnTo;
    } else {
      navigate(`/${language}/`);
    }
  };

  const backText = returnTo 
    ? (t('checkout.btnBack') || 'Back') + ' to checkout'
    : t('refund.backToHome') || 'Back to home';

  return (
    <div className="min-h-screen bg-slate-950">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <button 
          onClick={handleBackClick}
          className="text-primary hover:text-purple-400 transition-colors mb-8 inline-block cursor-pointer bg-transparent border-none"
        >
          ← {backText}
        </button>
        
        <h1 className="text-4xl font-heading font-bold text-white mb-8">
          {t('refund.title')}
        </h1>

        <div className="prose prose-invert prose-slate max-w-none">
          <section className="mb-12">
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-6 mb-6">
              <p className="text-slate-300 leading-relaxed mb-4">
                {t('refund.setupFeeNotice')}
              </p>
              <p className="text-slate-300 leading-relaxed">
                {t('refund.subscriptionNotice')}
              </p>
            </div>

            <div className="bg-primary/10 border border-primary/20 rounded-lg p-6">
              <p className="text-white font-semibold mb-2">
                {t('refund.exceptionalCircumstances')}
              </p>
              <p className="text-slate-300">
                {t('refund.exceptionalText')}
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">
              {t('refund.processTitle')}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-4">
              {t('refund.processText')}
            </p>
            <a href="mailto:info@dathent.com" className="text-primary hover:text-purple-400 transition-colors">
              info@dathent.com
            </a>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">
              {t('refund.earlyTerminationTitle')}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t('refund.earlyTerminationText')}{' '}
              <a href={`/${language}/terms`} className="text-primary hover:text-purple-400 transition-colors">
                {t('refund.termsLink')}
              </a>.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-sm text-slate-500">
            {t('refund.lastUpdated')}
          </p>
        </div>
      </div>
    </div>
  );
}
